import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-webhooks-logo',
  templateUrl: './webhooks-logo.component.html',
  styleUrls: ['./webhooks-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width.px]': 'size',
    '[style.height.px]': 'size'
  }
})
export class WebhooksLogoComponent {
  @Input() size = 24;
}
